// src/pages/KundeEditPage.jsx
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Heading, Input, Button, VStack } from "@chakra-ui/react";
import axios from "axios";

export default function KundeEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [kunde, setKunde] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/kunden/${id}`)
      .then((res) => setKunde(res.data))
      .catch((err) => console.error("Fehler beim Laden des Kunden:", err));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setKunde((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    await axios.put(`${process.env.REACT_APP_API_URL}/api/kunden/${id}`, kunde);
    navigate("/systemdaten/kundenliste");
  };

  if (!kunde) return <div>Lade Kundendaten...</div>;

  return (
    <Box maxW="2xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={5}>Kunde bearbeiten</Heading>
      <Heading size="sm" mb={3} color="blue.500">
                    Kunden-Kontakt </Heading>

      <VStack spacing={4} align="stretch">
        <Input name="anrede" placeholder="Anrede" value={kunde.anrede} onChange={handleChange} />
        <Input name="vorname" placeholder="Vorname" value={kunde.vorname} onChange={handleChange} />
        <Input name="nachname" placeholder="Nachname" value={kunde.nachname} onChange={handleChange} />
        <Input name="firma" placeholder="Firma" value={kunde.firma} onChange={handleChange} />
        <Input name="strasse" placeholder="Straße / Hausnummer" value={kunde.strasse} onChange={handleChange} />
        <Input name="plzOrt" placeholder="PLZ / Ort" value={kunde.plzOrt} onChange={handleChange} />
        <Input name="telefon" placeholder="Telefon" value={kunde.telefon} onChange={handleChange} />
        <Input name="mobil" placeholder="Mobil" value={kunde.mobil} onChange={handleChange} />
        <Input name="email" placeholder="Email" value={kunde.email} onChange={handleChange} />

               <Heading size="sm" mt={2} mb={2} color="blue.500">
                    Ansprechpartner-Kontakt
                </Heading>
        
       <Input name="ansprechpartnerVorname" placeholder="Ansprechpartner-Vorname" value={kunde.ansprechpartnerVorname} onChange={handleChange} />
        <Input name="ansprechpartnerNachname" placeholder="Ansprechpartner-Nachname" value={kunde.ansprechpartnerNachname} onChange={handleChange} /> 

        <Input name="ansprechpartnerTelefon" placeholder="Ansprechpartner-Telefon" value={kunde.ansprechpartnerTelefon} onChange={handleChange} /> 
        <Input name="ansprechpartnerMobil" placeholder="Ansprechpartner-Mobil" value={kunde.ansprechpartnerMobil} onChange={handleChange} /> 

         <Input name="ansprechpartnerEmail" placeholder="Ansprechpartner-Email" value={kunde.ansprechpartnerEmail} onChange={handleChange} /> 
          
             <Heading size="sm" mt={2} mb={2} color="blue.500">
                    Hinweis
                </Heading>

        <Input name="hinweis" placeholder="Hinweis" value={kunde.hinweis} onChange={handleChange} />   

        <Button colorScheme="green" onClick={handleSave}>Speichern</Button>
        <Button variant="outline" onClick={() => navigate(-1)}>Abbrechen</Button>
      </VStack>
    </Box>
  );
}